module.exports = __webpack_public_path__ + "img/Newbie_Dagger_02_Ranger.ad3ddcef.png";